<template lang="html">
  <div id="d-profile-page">

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-12 col-title">
          <h2 class="txt-breadcrumb">
            <span>Mi perfil</span>
            Mis datos
          </h2>

          <b-button class="btn-s1 bg-red btn-sm" style="float: right;background-color: black;border-color: black;" @click="openModal()">Descripción de puesto</b-button>

        </div>
      </div>
    </section>

    <section class="main-section">
      <b-form class="form" @submit="onSubmit">
        <div class="row">

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Nombre(s)">
              <b-form-input
                v-model="form.name"
                type="text"
                placeholder=""
                required
                disabled
              ></b-form-input>
            </b-form-group>
          </div>


          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Apellidos">
              <b-form-input
                v-model="form.lastname"
                type="text"
                placeholder=""
                required
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Correo electrónico">
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder=""
                required
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Telefono">
              <b-form-input
                v-model="form.phone"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>


          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Contacto de emergencia">
              <b-form-input
                v-model="form.emergency_contact"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Telefono de emergencia">
              <b-form-input
                v-model="form.emergency_phone"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="RFC">
              <b-form-input
                v-model="form.rfc"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="CURP">
              <b-form-input
                v-model="form.curp"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="IMSS">
              <b-form-input
                v-model="form.imss"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>


          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="No. de Cuenta bancaria">
              <b-form-input
                v-model="form.bank_account"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Departamento">
              <b-form-input
                v-model="form.departament"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          
          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Puesto">
              <b-form-input
                v-model="form.position"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Jefe Inmediato">
              <b-form-input
                v-model="form.immediate_boss"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Gerente de area">
              <b-form-input
                v-model="form.area_manager"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Agencia">
              <b-form-input
                v-model="form.agencies"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Pagadora">
              <b-form-input
                v-model="form.payers"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Dirección">
              <b-form-input
                v-model="form.address"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Nivel de tabulador">
              <b-form-input
                v-model="form.tablevels"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          
          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Fecha de Planta">
              <b-form-input
                v-model="form.plant_date"
                placeholder=""
                disabled
              ></b-form-input>
            </b-form-group>
          </div>




          <!-- <div class="col-12 mt-lg-4 text-center">
            <b-button type="submit" class="btn-s1 bg-red btn-lg btn-send">Guardar</b-button>
          </div> -->

        </div>
        <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
        <div v-html="modal.msg"></div>
        
      </sweet-modal>
      </b-form>
    </section>

    <sweet-modal ref="modalPosition" width="60%">

      <b-form class="form" @submit="onSubmitSign" >
        <div class="row">
          <div class="col-lg-12">
              <p style="text-align: center;background-color: black;color: white;"><b>Organigrama</b></p>
              <a :href="infoposition.imageUrl" target="_blank" rel="noopener noreferrer">
                <img :src="infoposition.imageUrl" width="40%">
              </a>

              <a :href="infoposition.documentUrl" target="_blank" rel="noopener noreferrer" class="btn-s1 bg-red btn-sm" style="background-color: black;"><i class="fas fa-download"></i> Descargar</a>
          </div>
          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Nombre">
              <b-form-input
                v-model="infoposition.name"
                type="text"
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Area">
              <b-form-input
                v-model="infoposition.area"
                type="text"
                disabled
              ></b-form-input>
            </b-form-group>
          </div>

          <div class="col-lg-6">
            <b-form-group class="mb-4 form-group-s1"
              label="Departamento">
              <b-form-input
                v-model="infoposition.departament"
                type="text"
                disabled
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-lg-6"></div>
          
          <div class="col-lg-12">
            <p style="text-align: center;background-color: black;color: white;"><b>Perfil del puesto (Requerimientos del ocupante)</b></p>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Escolaridad">
              <div v-html="infoposition.scholarship" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Requiere viajar">
              <div v-html="infoposition.requires_travel" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>

          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Tipo de puesto">
              <div v-html="infoposition.kind_position" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Idiomas">
              <div v-html="infoposition.languages" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>


          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Sistemas">
              <div v-html="infoposition.systems" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Habilidades y Competencias Genéricas">
              <div v-html="infoposition.skills" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Competencias y conocimientos específicos">
              <div v-html="infoposition.competencies" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Cualidades Personales">
              <div v-html="infoposition.qualities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          

          <div class="col-lg-12">
            <p style="text-align: center;background-color: black;color: white;"><b>Descripción del puesto (objetivo, funciones y responsabilidades)</b></p>
          </div>


          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Objetivo del puesto">
              <div v-html="infoposition.objective" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  </div>
          <div class="col-lg-12">Relaciones del puesto</div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Interior">

              <div v-html="infoposition.inside" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Exterior">

              <div v-html="infoposition.abroad" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Reporta a">
              <div v-html="infoposition.report_to" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Supervisa a">
              <div v-html="infoposition.supervises_to" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Material, herramientas y equipo asignado">
              <div v-html="infoposition.material_tools" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          
          <div class="col-lg-12">Resposabilidades</div>


          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Actividades Diarias">
              <div v-html="infoposition.daily_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Actividades Semanales">
              <div v-html="infoposition.weekly_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Actividades Quincenales">

              <div v-html="infoposition.biweekly_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Actividades Mensuales">
              <div v-html="infoposition.monthly_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Actividades Anuales">
              <div v-html="infoposition.annual_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Actividades Eventuales">
              <div v-html="infoposition.eventual_activities" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>

          <div class="col-lg-6">  </div>
          <div class="col-lg-12">Condiciones de trabajo</div>

          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Lugar">
              <div v-html="infoposition.place" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Principales riesgos a los que se expone el ocupante del puesto">
              <div v-html="infoposition.main_risks" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-12">  
            <b-form-group class="mb-4 form-group-s1"
              label="Políticas y Procedimientos">
              <div v-html="infoposition.politics_procedures" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Emisión">
              <div v-html="infoposition.issue" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Última actualización">
              <div v-html="infoposition.last_update" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Última revisión">
              <div v-html="infoposition.last_revision" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Próxima revisión">
              <div v-html="infoposition.next_review" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Elaboró">
              <div v-html="infoposition.elaborated" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Autorizó">
              <div v-html="infoposition.authorize" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6">  
            <b-form-group class="mb-4 form-group-s1"
              label="Revisó">
              <div v-html="infoposition.revised" style="border: 1px solid #e4e4e1;border-radius: 7px;color: #343333;background-color: #e9ecef;"></div>
            </b-form-group>
          </div>
          <div class="col-lg-6"></div>
          <div class="col-lg-12" v-if="!$root.user.signature"> 
              <div class="box-signature"  v-if="showSignaturePad" style="text-align: center;">
                  <VueSignaturePad class="signature-pad" ref="signaturePad" style="border:1px solid" />

                  <div class="box-buttons">
                      <a class="btn btn-primary" style="background-color: black; border-color: black;" @click="resetSignature">Intentar de nuevo</a>
                  </div>
              </div>
          </div>
          <div class="col-lg-12" v-else> 
              <img :src="$root.user.signature">
          </div>
          
          <b-button type="submit" v-if="!$root.user.signature" class="btn-s1 bg-red btn-lg mt-2 w-100">Guardar firma</b-button>



          
        </div>
      </b-form>
    </sweet-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: null,
        lastname: null,
        email: null,
        state_id: null,
        town_id: null,
        num_ext: null,
        neighborhood:null,
        zipcode:null,
      },
      states:[],
      towns:[],
      modal:{
        msg:'',
        icon:'',
        block:false,
      },
      infoposition:{

      },
      showSignaturePad:false,
      formSign:{
        signatureUrl:null,
      }
    }
  },
  watch:{
    'form.state_id':function(){
          this.getTowns();
    }
  },

  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.modal.block = true;
        this.modal.icon = '';
        this.modal.msg = 'Guardando informacion...';
        this.$refs.modal.open();

        axios.post(tools.url("/api/user/profile"), this.form).then((response)=>{
          this.modal.block = false;
            this.modal.icon = 'success';
            this.modal.msg = response.data.msg;
            this.$root.auth();
        }).catch((error)=>{
          this.modal.block = false;
            this.modal.icon= "error";
            this.modal.msg = error.response.data;
            
        });
    },
    onSubmitSign(event) {
      event.preventDefault();
      this.$refs.modalPosition.close();
      this.modal.block = true;
        this.modal.icon = '';
        this.modal.msg = 'Guardando informacion...';
        this.$refs.modal.open();

        const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
        this.formSign.signatureUrl = data;

        axios.post(tools.url("/api/user/profileSign"), this.formSign).then((response)=>{
          
          this.modal.block = false;
            this.modal.icon = 'success';
            this.modal.msg = 'Firma guardada correctamante';
            this.$root.auth();
        }).catch((error)=>{
          this.modal.block = false;
            this.modal.icon= "error";
            this.modal.msg = error.response.data;
            
        });
    },

    getStates(){
      axios.get(tools.url('/api/states')).then((response)=>{
        this.states = response.data;
      }).catch((error)=>{
         console.log(error);
      });
    },

    getTowns(){
      if(this.form.state_id){
        axios.get(tools.url('/api/towns/' + this.form.state_id)).then((response)=>{
          this.towns = response.data;
        }).catch((error)=>{
          console.log(error);
        });
      }
    },
    getInfoPosition(){
      axios.get(tools.url('/api/positions/' + this.$root.user.positions_id)).then((response)=>{
          this.infoposition = response.data;
        }).catch((error)=>{
          console.log(error);
        });
    },
    resetSignature() {
        this.$refs.signaturePad.clearSignature();
      },
      openModal(){
        this.$refs.modalPosition.open();
        setTimeout(()=>{ this.showSignaturePad = true; }, 500);
      }
  },
  mounted(){
    this.getStates();
    this.getTowns();
    this.getInfoPosition();

    this.form = {
        name: this.$root.user.name,
        lastname: this.$root.user.lastname,
        email: this.$root.user.email,

        phone: this.$root.user.phone,
        emergency_contact: this.$root.user.emergency_contact,
        emergency_phone: this.$root.user.emergency_phone,
        rfc: this.$root.user.rfc,
        curp: this.$root.user.curp,
        imss:this.$root.user.imss,
        bank_account:this.$root.user.bank_account,
        position:this.$root.user.position,

        immediate_boss:this.$root.user.immediate_boss,
        area_manager:this.$root.user.area_manager,
        agencies:this.$root.user.agencies,
        payers:this.$root.user.payers,
        address:this.$root.user.address,
        tablevels:this.$root.user.tablevels,
        plant_date:this.$root.user.plant_date,
        departament:this.$root.user.departament,
       
    };
  }
}
</script>
